const pointsMailList = []

export default {
  pointsMailList
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/points-mail-home-page/store/state.js